module.exports = __webpack_public_path__ + "img/logo.e985c03b.png";